import React from 'react';
import { Check } from 'lucide-react';
import './About.css';

const About = ({ data }) => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <p className="section-subtitle">{data.subtitle}</p>
            <h2 className="section-title">{data.title}</h2>
            <p className="about-description">{data.description}</p>
          </div>

          <div className="about-highlights">
            {data.highlights.map((highlight, index) => (
              <div key={index} className="highlight-card">
                <div className="highlight-icon">
                  <Check size={24} />
                </div>
                <h3 className="highlight-number">{highlight.number}</h3>
                <p className="highlight-label">{highlight.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
